// extracted by mini-css-extract-plugin
export default {"container":"UserInfoTab_container__C7Kfh","textTitle":"UserInfoTab_textTitle__lyAa4","textLabel":"UserInfoTab_textLabel__KYwKA","textValue":"UserInfoTab_textValue__m9tDH"};